module.exports = __webpack_public_path__ + "img/panoramic-main.78c23f75.jpg";